import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Global from 'models/Global';
import BootstrapData from 'models/BootstrapData';
import MainBaseView from 'views/MainBaseView';
import FeatureToggleUtils from 'FeatureToggleUtils';
import { instanaTrackPage } from '@bizzabo/instana-api';
import { initializeSnowplowTrackerIfEnabled } from '../utils/SnowplowUtils';
import { renderVirtualVenueBanner } from '../views/reactViews/VirtualVenueBanner';
import { renderAttendeeLogin } from '../views/reactViews/AttendeeLogin';
import { renderSsoEmailErrorModal } from '../views/reactViews/SsoEmailErrorModal';
import { saveUrlParamsToSessionStorage } from '../utils/saveUrlParamsToSessionStorage';

var MainTweetsView = MainBaseView.extend({

    el: $(document.body),

    initialize: function(options) {
        options = options || {};
        options.bootstrapData = {
            event: BootstrapData('bootstrap-data-event'),
            eventID: BootstrapData('bootstrap-data-event').id,
            settings: BootstrapData('bootstrap-data-settings'),
            siteConf: BootstrapData('bootstrap-data-siteConf'),
            me: BootstrapData('bootstrap-data-me'),
            config: BootstrapData('bootstrap-data-config'),
            isJoined: BootstrapData('bootstrap-data-isJoinedObject').isJoined,
            isCookieConsentEnabled: BootstrapData('bootstrap-data-isCookieConsentEnabled')
        };
        saveUrlParamsToSessionStorage({
            windowLocationSearch: window?.location?.search,
            eventId: options?.bootstrapData?.event?.id,
        });
        FeatureToggleUtils.mergeFeatureToggleWithConfig();
        MainBaseView.prototype.initialize.apply(this, arguments);
        Global.set('page', 'tweets');
        instanaTrackPage('Tweets');
        initializeSnowplowTrackerIfEnabled();
        renderVirtualVenueBanner();
        renderAttendeeLogin();
        renderSsoEmailErrorModal();
    }

});

new MainTweetsView({
    el: $(document.body)
});

export default MainTweetsView;

